import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Col, Row } from 'react-flexbox-grid';
import { BuildCard } from '@saucelabs/sl-component-build-card';
import { GroupByDate } from '@saucelabs/sl-component-group-by-date';
import { records as buildsRecords } from '@saucelabs/sl-module-builds';

import SeeAllButton from './SeeAllButton';
import RenderResults from './RenderResults';
import Styles from './List.styles';


const Builds = ({
  builds,
  currentUser,
  expandedBuilds,
  handleStopBuild,
  failedJobs,
  isOpenSauceUser,
  onToggle,
  showSeeAllButton,
}) => (
  <Row>
    <Col xs={12}>
      <div className={Styles.list}>
        <RenderResults size={builds.size}>
          <GroupByDate datePath={(item) => item.props.build.get('creation_time')}>
            {builds.map((build) => {
              const isOwner = build.owner === currentUser;
              const onStopBuild = isOwner && handleStopBuild ?
                () => handleStopBuild({ id: build.id }) : null;

              return (
                <BuildCard
                  key={build.id}
                  build={build}
                  handleStopBuild={onStopBuild}
                  isOpen={expandedBuilds.includes(build.id)}
                  isOwnerOpenSauce={isOpenSauceUser}
                  jobs={failedJobs.get(build.name, [])}
                  onToggle={() => {
                    onToggle({
                      build: build.id,
                      isOpen: expandedBuilds.includes(build.id),
                    });
                  }}
                />
              );
            })}
          </GroupByDate>
        </RenderResults>
        {showSeeAllButton && <SeeAllButton />}
      </div>
    </Col>
  </Row>
);

Builds.propTypes = {
  builds: ImmutablePropTypes.listOf(
    ImmutablePropTypes.recordOf(buildsRecords.BuildRecordClass).isRequired,
  ).isRequired,
  currentUser: PropTypes.string.isRequired,
  expandedBuilds: ImmutablePropTypes.list.isRequired,
  failedJobs: ImmutablePropTypes.mapOf(
    PropTypes.arrayOf(ImmutablePropTypes.record).isRequired,
    PropTypes.string.isRequired,
  ).isRequired,
  handleStopBuild: PropTypes.func,
  isOpenSauceUser: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  showSeeAllButton: PropTypes.bool,
};

Builds.defaultProps = {
  handleStopBuild: null,
  isOpenSauceUser: false,
  showSeeAllButton: true,
};

export default Builds;
